import type { ComplaintRootCause, keyPair } from "@repo/models";

import { hasValue } from "@repo/helpers";

import type { Complaint } from "../../../models";

/**
 * Root Cause dropdown options for the incident's current Reporting Tag. The saved Root Cause stays an option under
 * the saved Reporting Tag even when that tag no longer offers it, so existing incidents keep showing it.
 */
export function getRootCauseOptions(
	rootCauses: ComplaintRootCause[] | undefined,
	reportingTagId: number | undefined,
	savedIncident: Complaint | undefined,
): keyPair[] {
	const options: keyPair[] = (rootCauses ?? [])
		.filter((r) => r.reportingTagIds.includes(reportingTagId))
		.map((r) => ({ id: r.id, value: r.value }));

	const { reportingTagId: savedTagId, rootCauseId, rootCauseName } = savedIncident ?? {};
	const onSavedTag = (savedTagId ?? null) === (reportingTagId ?? null);
	if (hasValue(rootCauseId) && onSavedTag && !options.some((o) => o.id === rootCauseId))
		options.push({ id: rootCauseId, value: rootCauseName });

	return options;
}
